export class AerosolOrdonnanceInformationsForm {
  nombreNebuliseurParMois: number;
  prescriptionMois: number;

  constructor(nombreNebuliseurParMois: number, prescriptionMois: number) {
    this.nombreNebuliseurParMois = nombreNebuliseurParMois;
    this.prescriptionMois = prescriptionMois;
  }

  toAPI(): AerosolOrdonnanceInformationsFormAPI {
    return {
      nombre_nebuliseur_par_mois: this.nombreNebuliseurParMois,
      prescription_duree: `${this.prescriptionMois} mois`,
    };
  }
}

export type AerosolOrdonnanceInformationsFormAPI = {
  nombre_nebuliseur_par_mois: number;
  prescription_duree: string;
};
